import { render, staticRenderFns } from "./MyInfo.vue?vue&type=template&id=647b4086&scoped=true&"
import script from "./MyInfo.vue?vue&type=script&lang=ts&"
export * from "./MyInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MyInfo.vue?vue&type=style&index=0&id=647b4086&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b4086",
  null
  
)

export default component.exports